import React, { Component } from 'react';
import { Tabs, Menu, Input, Button, message, Modal } from 'antd';
import dayjs from 'dayjs'
import './App.css';
import Logo from './img/logo.png'
import BOX1 from './img/box/box1.jpg'
import BOX2 from './img/box/box2.jpg'
import BOX3 from './img/box/box3.jpg'
import BOX4 from './img/box/box4.jpg'
import WATER1 from './img/water/water1.jpg'
import WATER2 from './img/water/water2.jpg'
import WATER3 from './img/water/water3.jpg'
import EYEWRAP1 from './img/eyewrap/eyewrap1.jpg'
import EYEWRAP2 from './img/eyewrap/eyewrap2.jpg'
import EYEWRAP3 from './img/eyewrap/eyewrap3.jpg'
import ContactUs from './img/contactUs.png'
import IndustryInfo from './img/industryInfo.png'
import ProductCenter from './img/productCenter.png'
import Footer from './img/footer.png'
import EyeLotion1 from './img/eyeLotion1.jpg'
import EyeLotion2 from './img/eyeLotion2.jpg'
import Nursingliquid1 from './img/nursingliquid1.jpg'
import Nursingliquid2 from './img/nursingliquid2.jpg'
import Haitao1 from './img/haitao1.jpg'
import Ylqx from './img/ylqx.png'
import Yyzz from './img/yyzz.png'
import dierleiyiliaobeian from './img/dierleiyiliaobeian.png'
import OkJing from './img/okjing.png'
import OkWash from './img/okwash.png'
import OkWash2 from './img/okwash2.png'
import BriefIntroduction from './img/briefIntroduction.png'
import CounselingCenter from './img/counselingCenter.png'
import Boshidun1 from "./img/boshidun1.png"
import Boshidun2 from "./img/boshidun2.png"
import Jinteshu1 from "./img/jingteshu1.png"
import Jinteshu2 from "./img/jingteshu2.png"
import Jinteshu21 from "./img/jingteshu21.png"
import Jinteshu22 from "./img/jingteshu22.png"
import Jinteshu23 from "./img/jingteshu23.png"
import Jinteshu24 from "./img/jingteshu24.png"
import Weikang1 from "./img/weikang1.png"
import Weikang2 from "./img/weikang2.png"
import Weikang3 from "./img/weikang3.png"
import Weikang4 from "./img/weikang4.png"
import Haitao2 from "./img/haitao1.png"
import Haitao3 from "./img/haitao3.jpg"
import beianimg from "./img/beian.png"
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      menuKey: "2",
      page: 1,
      type: "nursingliquid",
      text1: "",
      text2: "",
      src1: "",
      src2: "",
    }
  }

  componentDidMount() {
  }

  menuSelect = (value) => {
    console.log(value)
    let { type } = this.state
    if (value.keyPath.length > 1) {
      type = value.keyPath[0]
    }
    this.setState({
      type,
      menuKey: value.key
    }, () => {
      let anchorElement = document.getElementById((value.keyPath[1] || value.keyPath[0]));
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: 'smooth' });
      }
    })
  }


  tabChange1 = (value) => {
    this.setState({
      type: value
    })
  }
  onDocumentComplete(pages) {
    this.setState({ page: 1, pages: pages });
  }
  onChange(page) {
    this.setState({
      page: page,
    });
  }

  save = () => {
    let { text1, text2 } = this.state
    let msg = text1 ? text1.trim() : ""
    let tell = text2 ? text1.trim() : ""
    if (msg && tell) {
      Modal.info({
        okText: "好的",
        title: '提交成功！',
      });
      this.setState({
        text1: "",
        text2: "",
      })
    } else {
      message.warn("请将表单填写完整后再提交！")
    }
  }
  render() {
    return (
      <div className="App">
        <div className="center">
          <div className="topNav">
            <div style={{ width: 1440, margin: "auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ background: "white" }}>
                <img style={{ width: 200, height: 80 }} src={Logo} alt="" />
              </div>
              <Menu mode="horizontal" onSelect={this.menuSelect} selectedKeys={[this.state.menuKey]}>
                <Menu.Item key="briefIntroduction">
                  网站简介
                </Menu.Item>
                <Menu.SubMenu onTitleClick={this.menuSelect.bind(this, {
                  key: "product",
                  keyPath: ["product"]
                })} key="product" title="产品信息展示中心" >
                  <Menu.Item key="nursingliquid">
                    硬镜护理液
                  </Menu.Item>
                  <Menu.Item key="eyeLotion">
                    硬镜润眼液
                  </Menu.Item>
                  {/* <Menu.Item key="haitao">
                    硬镜系列海淘产品
                  </Menu.Item> */}
                  {/* <Menu.Item key="eyewrap">
                    蒸汽眼罩
                  </Menu.Item>
                  <Menu.Item key="box">
                    伴侣盒
                  </Menu.Item> */}
                </Menu.SubMenu>
                <Menu.Item key="news">
                  行业及产品资讯
                </Menu.Item>
                <Menu.Item key="counselingCenter">
                  咨询中心
                </Menu.Item>
                <Menu.Item key="contact">
                  联系我们
                </Menu.Item>
              </Menu>
            </div>
          </div>
          <div id="briefIntroduction" style={{ paddingTop: 120 }}>
            <div style={{ background: "#fff", textAlign: "center", }}>
              <img src={BriefIntroduction} alt="" style={{ width: "100%" }} />
            </div>
          </div>
          <div id="product" className="product">
            <div className="wrap">
              <div className="title" style={{ position: "relative", marginBottom: 72 }}>
                <img src={ProductCenter} alt="" style={{ width: 501, height: 103 }} />
              </div>
              <div style={{ width: 250, margin: "auto", textAlign: "center", position: "relative" }}>
                <div style={{ position: "absolute", right: "-3%", top: "20%" }}>
                  <Tabs activeKey={this.state.type} tabBarGutter={60} onChange={this.tabChange1}>
                    <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>硬镜护理液</span>} key="nursingliquid"></Tabs.TabPane>
                    <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>硬镜润眼液</span>} key="eyeLotion"></Tabs.TabPane>
                    {/* <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>硬镜系列海淘产品</span>} key="haitao"></Tabs.TabPane> */}
                    {/* <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>蒸汽眼罩</span>} key="eyewrap"></Tabs.TabPane> */}
                    {/* <Tabs.TabPane tab={<span style={{ fontSize: 20 }}>伴侣盒</span>} key="box"></Tabs.TabPane> */}
                  </Tabs>
                </div>
              </div>
              <div style={{ width: "1250px", margin: "auto", height: 500, marginTop: 156 }}>
                <ul style={{ display: "flex", justifyContent: "center" }}>
                  {
                    // 海淘
                    this.state.type === "haitao" && (
                      <>
                        <li onClick={() => { this.setState({ visible: true, src1: Haitao2, src2: Haitao3 }) }} style={{ cursor:"pointer", width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={Haitao1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            【海淘】培克能RGP镜护理液240ml
                          </div>
                        </li>
                      </>
                    )
                  }
                  {
                    // 护理液
                    this.state.type === "nursingliquid" && (
                      <>
                        <li onClick={() => { this.setState({ visible: true, src1: Jinteshu1, src2: Jinteshu2 }) }} style={{ cursor:"pointer", width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={Nursingliquid2} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            镜特舒 进口护理液120ml
                          </div>
                        </li>
                        <li onClick={() => { this.setState({ visible: true, src1:Weikang1, src2: Weikang2,src3: Weikang3,src4: Weikang4 }) }} style={{ cursor:"pointer", width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={EyeLotion2} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            欧几里德 护理液120ml
                          </div>
                        </li>
                      </>
                    )
                  }
                  {
                    // 润眼液
                    ["eyeLotion"].includes(this.state.type) && (
                      <>
                        <li onClick={() => { this.setState({ visible: true, src1: Boshidun1, src2: Boshidun2 }) }} style={{ cursor:"pointer", width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={Nursingliquid1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            博视顿 先进润滑液10ml
                          </div>
                        </li>
                        <li onClick={() => { this.setState({ visible: true, src1: Jinteshu21, src2: Jinteshu22, src3: Jinteshu23, src4: Jinteshu24 }) }} style={{cursor:"pointer", width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={EyeLotion1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            欧几里德 保湿型润滑液10ml
                          </div>
                        </li>
                        
                      </>
                    )
                  }
                  {
                    // 伴侣盒
                    this.state.type === "box" && (
                      <>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={BOX1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            3N眼镜四代隐形眼镜清洗器
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={BOX2} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            eyekan新款凯达HL-988隐形眼镜清洗器
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={BOX3} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            凯达小黄鸭卡通隐形眼镜盒
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={BOX4} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            美尼康硬性隐形眼镜ITH双头镜盒伴侣盒
                          </div>
                        </li>
                      </>
                    )
                  }
                  {
                    this.state.type === "water" ? (
                      <>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={WATER1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            LaPeche拉拜诗樱桃小丸子联名洗眼液
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={WATER2} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            拉拜诗LaPeche维生素B12洗眼液
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={WATER3} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            日本科奈美维生素B12洗眼液
                          </div>
                        </li>
                      </>
                    ) : null
                  }
                  {
                    // 蒸汽眼罩
                    this.state.type === "eyewrap" ? (
                      <>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={EYEWRAP1} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            LaPeche拉拜诗无香热敷蒸汽眼罩
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA", marginRight: 12 }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={EYEWRAP2} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            眸论5片装香味热敷蒸汽眼罩
                          </div>
                        </li>
                        <li style={{ width: 284, height: 380, boxSizing: "border-box", padding: 48, listStyleType: "none", border: "1px solid #EAEAEA" }}>
                          <div className="img" style={{ width: 188, height: 188 }}>
                            <img src={EYEWRAP3} alt="" style={{ width: 188, height: 188 }} />
                          </div>
                          <div className="subtitle" style={{ fontSize: 20, color: "#0F1429", textAlign: "left", marginTop: 42 }}>
                            眸论春日娃娃5片装香味热敷蒸汽眼罩
                          </div>
                        </li>
                      </>
                    ) : null
                  }
                </ul>
              </div>
            </div>
          </div>
          <div id="news" style={{ marginBottom: "200px" }}>
            <div style={{ background: "#fff", textAlign: "center", }}>
              <img src={IndustryInfo} alt="" style={{ width: 510, height: 103 }} />
            </div>
            <div style={{ margin: "72px 190px 0" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <a target='_blank' href="/inyx?url=https://images.vsigo.cn/zhuanti/20220809/4.png">
                  <div style={{ width: 504, height: 375, background: "red", position: "relative" }}>
                    <img src={OkJing} style={{ height: "100%", width: "100%" }} alt="" />
                    <div style={{ boxShadow: "0px 0px 10px 0px rgba(187,187,187,0.3000)", position: "absolute", width: 434, height: 209, background: "#fff", top: "299px", left: "35px", boxSizing: "border-box", padding: "30px 48px 26px", borderRadius: 4 }}>
                      <p style={{ textAlign: "center", fontSize: 18, color: "#222222" }}>硬镜汇</p>
                      <p style={{ textAlign: "center", fontSize: 20, color: "#222222", marginTop: 20, fontWeight: "bold" }}>戴OK镜的孩子，长大了怎么办？</p>
                      <p style={{ textAlign: "center", fontSize: 16, color: "#999999", marginTop: 16 }}>2022.08.01</p>
                    </div>
                  </div>
                </a>
                <a target='_blank' href="/inyx?url=https://images.vsigo.cn/zhuanti/20220809/5.png">
                  <div style={{ width: 504, height: 375, background: "red", position: "relative" }}>
                    <img src={OkWash} style={{ height: "100%", width: "100%" }} alt="" />
                    <div style={{ boxShadow: "0px 0px 10px 0px rgba(187,187,187,0.3000)", position: "absolute", width: 434, height: 209, background: "#fff", top: "299px", left: "35px", boxSizing: "border-box", padding: "30px 48px 26px", borderRadius: 4 }}>
                      <p style={{ textAlign: "center", fontSize: 18, color: "#222222" }}>硬镜汇</p>
                      <p style={{ textAlign: "center", fontSize: 20, color: "#222222", marginTop: 20, fontWeight: "bold" }}>护理OK镜可以免搓洗吗？</p>
                      <p style={{ textAlign: "center", fontSize: 16, color: "#999999", marginTop: 16 }}>2022.08.01</p>
                    </div>
                  </div>
                </a>
                <a target="_blank" href="/inyx?url=https://images.vsigo.cn/zhuanti/20220809/6.png">
                  <div style={{ width: 504, height: 375, background: "red", position: "relative" }}>
                    <img src={OkWash2} style={{ height: "100%", width: "100%" }} alt="" />
                    <div style={{ boxShadow: "0px 0px 10px 0px rgba(187,187,187,0.3000)", position: "absolute", width: 434, height: 209, background: "#fff", top: "299px", left: "35px", boxSizing: "border-box", padding: "30px 48px 26px", borderRadius: 4 }}>
                      <p style={{ textAlign: "center", fontSize: 18, color: "#222222" }}>硬镜汇</p>
                      <p style={{ textAlign: "center", fontSize: 20, color: "#222222", marginTop: 20, fontWeight: "bold" }}>OK镜护理不当会对眼睛造成什么危害</p>
                      <p style={{ textAlign: "center", fontSize: 16, color: "#999999", marginTop: 16 }}>2022.08.01</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div id="counselingCenter" style={{ marginBottom: 72, }}>
            <div style={{ background: "#fff", textAlign: "center", }}>
              <img src={CounselingCenter} alt="" style={{ width: 510, height: 103 }} />
            </div>
            <div style={{ textAlign: "center", marginTop: 24 }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <span style={{ fontSize: 22, fontWeight: 700, marginRight: 12 }}>问题留言</span>
                <Input.TextArea onChange={(e) => { this.setState({ text1: e.target.value }) }} value={this.state.text1} placeholder='请输入' rows={4} style={{ width: 800 }} />
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: 24 }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <span style={{ fontSize: 22, fontWeight: 700, marginRight: 12 }}>联系方式</span>
                <Input.TextArea onChange={(e) => { this.setState({ text2: e.target.value }) }} value={this.state.text2} placeholder='请输入' rows={1} style={{ width: 800 }} />
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center", marginBottom: 24 }}><Button onClick={this.save} style={{ width: 300, height: 40 }} type="primary">提交</Button></div>
          <div id="contact" style={{ marginBottom: 72 }}>
            <div style={{ background: "#fff", textAlign: "center", }}>
              <img src={ContactUs} alt="" style={{ width: 510, height: 103 }} />
            </div>
          </div>
          <div className="footer" style={{ textAlign: "center" }}>
            <img src={Footer} style={{ width: "100%", height: 278 }} alt="" />
          </div>
          <div style={{ background: "#222222", padding: "24px 0", textAlign: "center", color: "white" }}>
            <a style={{ color: "white", marginRight: 64 }} href={`https://s1.rgpmall.com/rgp/cert/%E4%BA%92%E8%81%94%E7%BD%91%E8%8D%AF%E5%93%81%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E5%A4%87%E6%A1%88%E5%87%AD%E8%AF%81.jpg?t=${dayjs().format('YYYYMMDD')}`} target='_blank'>互联网药品医疗器械信息服务备案凭证：苏网药械信备字[2026]000017号</a>
            <a href="https://beian.miit.gov.cn/" style={{color: 'white'}} target="_blank">苏ICP备2020060826号</a>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32010402001479" rel="noreferrer" target="_blank" style={{color:'white'}}>｜ <img style={{width:'16px',position:'relative',top:'-2px'}} src={beianimg} /> 苏公网安备32010402001479</a>
            <a style={{ color: "white" }} href={Ylqx} target='_blank'>｜医疗器械经营许可证：苏宁食药监械经营许20200297号</a>
            <a style={{ color: "white" }} href={Yyzz} target='_blank'>｜经营者信息</a>
            <a style={{ color: "white" }} href={dierleiyiliaobeian} target='_blank'>｜第二类医疗器械经营备案凭证：苏宁备药监械经营备20221099号</a>
            {/* <a href={SM1} target='_blank' rel="noopener noreferrer" style={{ color: '#fff' }} >医疗器械网络销售备案信息</a> */}
          </div>
        </div>
        <style jsx="true">
          {
            `
            .App .ant-menu-horizontal {
              border-bottom: none !important;
            }
            `
          }
        </style>
        <Modal footer={null} okText="确认" cancelText="取消" visible={this.state.visible}  onCancel={() => { this.setState({ visible: false, src3: '', src4: '' }) }} width={1200}>
          <div style={{height:600,overflow:"scroll"}}>
            <img style={{ width: "100%" }} src={this.state.src1} alt="" />
            <img style={{ width: "100%" }} src={this.state.src2} alt="" />
            <img style={{ width: "100%" }} src={this.state.src3} alt="" />
            <img style={{ width: "100%" }} src={this.state.src4} alt="" />
          </div>
        </Modal>
      </div>
    );
  }
}

export default App;
